<form #hrAdminForm ngNoForm method="post" style="display: none;" [action]="url">
  <input type="text" id="route" name="route" value="{{hrAdminRoute}}">
  <input type="text" id="token" name="token" value="{{member.token}}">
  <input type="text" id="token" name="refreshToken" value="{{member.refreshToken}}">
</form>
